module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/fridge/fridge.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/fridge/fridge.png
// module id = 568
// module chunks = 0